export default __webpack_public_path__ + "static/media/1x1.104ca188.svg";